import React, { useState, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl'; // <--- 1. Импортируем хук
import styles from './OptionItem.module.css';
import { FiCircle, FiCheckSquare, FiX } from 'react-icons/fi';
import { QUESTION_TYPES } from '../../questionTypeConstants';
import Input from '../../../common/Input/Input';

const OptionItem = ({ questionType, option, onUpdate, onDelete, showDeleteButton, displayIconType }) => {
    const intl = useIntl(); // <--- 2. Вызываем хук для доступа к функциям перевода
    const [text, setText] = useState(option.text);
    const inputRef = useRef(null);

    useEffect(() => {
        setText(option.text);
    }, [option.text]);

    const handleTextChange = (e) => {
        setText(e.target.value);
    };

    const handleBlur = () => {
        if (text !== option.text) {
            onUpdate(text);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            inputRef.current.blur();
        }
    };

    let IconComponent;
    if (displayIconType === QUESTION_TYPES.RADIO) {
        IconComponent = FiCircle;
    } else if (displayIconType === QUESTION_TYPES.CHECKBOX) {
        IconComponent = FiCheckSquare;
    } else {
        IconComponent = null;
    }

    return (
        <div className={styles.optionItem}>
            {IconComponent ? <IconComponent className={styles.optionIcon} /> : <span className={styles.optionIconPlaceholder}></span>}
            <Input
                ref={inputRef}
                type="text"
                value={text}
                onChange={handleTextChange}
                onBlur={handleBlur}
                onKeyPress={handleKeyPress}
                placeholder={intl.formatMessage({ id: "question.optionPlaceholder" })}
                className={styles.optionInput}
                wrapperClassName={styles.inputWrapper}
            />
            {showDeleteButton && (
                <button
                    onClick={onDelete}
                    className={styles.deleteOptionButton}
                    // --- 3. ИСПОЛЬЗУЕМ ПЕРЕВОД ---
                    title={intl.formatMessage({ id: "question.option.deleteTooltip" })}
                >
                    <FiX />
                </button>
            )}
        </div>
    );
};

export default OptionItem;
